import "../style/homepage.css";
import { Search } from "./search";
import Navbar from "./navbar";
import {Footer} from "./footer";
import {Whyscanel} from "./whyscanel";
import { AuthContext } from "./auth/auth";
import app from '../firebase/base';
import React, { useState,useContext } from 'react';
import firebase from "firebase/compat/app";
import Tools from "./tools";





function Homepage() {

  const { currentUser } = useContext(AuthContext);
  const [isSignUpPage, setisSignUpPage] = useState(false);


  return (
    <div className="App">
      <div className="gradient__bg">
        <Navbar/>
        <Search />
        <Tools/>
        <Whyscanel/>
      </div>
     <Footer/>
    </div>
  );
}
export default Homepage;